module.exports = __webpack_public_path__ + "static/Slider6-f41b7bd08f7703dbff3a3ee1112a86ca.jpg";